import {HomeMatchConfigurationSourceSection} from "@pg-rp/common-types";

import {HomeMatchBasicPreferencesFlowSource} from "../types/HomeMatchBasicPreferencesFlowTypes";

export type HomeMatchConfigurationSourceSectionTrigger = "summaryModal" | "stayModal";

interface IGetHomeMatchConfigurationSourceSectionParams {
    flowSource: HomeMatchBasicPreferencesFlowSource;
    trigger: HomeMatchConfigurationSourceSectionTrigger;
}

export const getHomeMatchConfigurationSourceSection = (params: IGetHomeMatchConfigurationSourceSectionParams): HomeMatchConfigurationSourceSection => {
    const {flowSource, trigger} = params;

    if (flowSource === "afterLead") {
        return trigger === "summaryModal"
            ? HomeMatchConfigurationSourceSection.RP_APPLICATION_SEND_MODAL
            : HomeMatchConfigurationSourceSection.RP_APPLICATION_SEND_STAY;
    }

    return trigger === "summaryModal" ? HomeMatchConfigurationSourceSection.RP_SHOW_PRICE_MODAL : HomeMatchConfigurationSourceSection.RP_SHOW_PRICE_STAY;
};
import {HomeMatchConfigurationSourceSection} from "@pg-rp/common-types";

import {HomeMatchBasicPreferencesFlowSource} from "../types/HomeMatchBasicPreferencesFlowTypes";

export type HomeMatchConfigurationSourceSectionTrigger = "summaryModal" | "stayModal";

interface IGetHomeMatchConfigurationSourceSectionParams {
    flowSource: HomeMatchBasicPreferencesFlowSource;
    trigger: HomeMatchConfigurationSourceSectionTrigger;
}

export const getHomeMatchConfigurationSourceSection = (params: IGetHomeMatchConfigurationSourceSectionParams): HomeMatchConfigurationSourceSection => {
    const {flowSource, trigger} = params;

    if (flowSource === "afterLead") {
        return trigger === "summaryModal"
            ? HomeMatchConfigurationSourceSection.RP_APPLICATION_SEND_MODAL
            : HomeMatchConfigurationSourceSection.RP_APPLICATION_SEND_STAY;
    }

    return trigger === "summaryModal" ? HomeMatchConfigurationSourceSection.RP_SHOW_PRICE_MODAL : HomeMatchConfigurationSourceSection.RP_SHOW_PRICE_STAY;
};
